import { render, staticRenderFns } from "./SaleAssistant.vue?vue&type=template&id=2759113b&scoped=true"
import script from "./SaleAssistant.vue?vue&type=script&lang=js"
export * from "./SaleAssistant.vue?vue&type=script&lang=js"
import style0 from "./SaleAssistant.vue?vue&type=style&index=0&id=2759113b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2759113b",
  null
  
)

export default component.exports